import Vue from 'vue';
import {
	Carousel,
	CarouselItem,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Drawer,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
	Input,
	Timeline,
	TimelineItem,
  Tabs,
  TabPane
} from 'element-ui';

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Drawer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Tabs)
Vue.use(TabPane)



// WEBPACK FOOTER //
// ./src/assets/element_ui.js